'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/stages/paths');

var loading = { loadingStagesDialog: true };

exports.default = function (feisId) {
  return function (state) {

    var currentStewardingDay = state.getIn(['stages', 'ui', feisId, 'currentStewardingDay']);

    if ((0, _paths2.stagesAreLoading)(state, feisId)) {
      return loading;
    }

    var stages = (0, _paths2.getStages)(state, feisId).map(function (id) {
      return (0, _paths2.getStage)(state, id);
    }) || (0, _immutable.List)();

    var stagesByDay = stages.reduce(function (m, s) {
      var dt = s.get('dt');

      var day = m.get(dt) || (0, _immutable.List)();

      return m.set(dt, day.push(s));
    }, (0, _immutable.Map)());

    var allStagesForCurrentDay = stagesByDay.get(currentStewardingDay) || (0, _immutable.List)();

    if (stages.size === 0 || allStagesForCurrentDay.size === 0) {
      return {
        loadingStagesDialog: false,
        stages: stages,
        currentStewardingDay: currentStewardingDay,
        allStagesForCurrentDay: allStagesForCurrentDay,
        eventsForCurrentStage: eventsForCurrentStage,
        filteredEventsForCurrentStage: filteredEventsForCurrentStage,
        currentEventIdx: currentEventIdx,
        currentEvent: currentEvent,
        currentStage: currentStage
      };
    }

    var currentStageId = state.getIn(['stages', 'ui', feisId, 'currentStage']);

    var currentStage = allStagesForCurrentDay.find(function (s) {
      return s.get('id') === currentStageId;
    });

    if (!currentStage || (0, _paths2.stageEventsAreLoading)(state, currentStageId)) {
      return loading;
    }

    var eventsForCurrentStage = ((0, _paths2.getEventsOnStage)(state, currentStage.get('id')) || (0, _immutable.List)()).filter(function (ev) {
      return !ev.get('placeholder');
    });

    if (!eventsForCurrentStage.every(function (e) {
      return (0, _paths.getEvent)(state, e.get('id'));
    })) {
      return loading;
    }

    eventsForCurrentStage = eventsForCurrentStage.map(function (ev) {
      return (0, _paths.getEvent)(state, ev.get('id')).merge(ev);
    });

    var allClosedEvents = eventsForCurrentStage.filter(function (e) {
      return e.get('is_ci_closed');
    });

    var currentClosedEvent = allClosedEvents.sort(function (a, b) {
      return b.get('closed_at') - a.get('closed_at');
    }).get(0);

    var openEvents = eventsForCurrentStage.filter(function (event) {
      return !event.get('is_ci_closed') || event.get('is_ci_closed') === 0;
    });

    var filteredEventsForCurrentStage = currentClosedEvent && openEvents.unshift(currentClosedEvent) || openEvents;

    if (eventsForCurrentStage.size === 0) {
      return {
        loadingStagesDialog: false,
        stages: stages,
        currentStewardingDay: currentStewardingDay,
        allStagesForCurrentDay: allStagesForCurrentDay,
        eventsForCurrentStage: eventsForCurrentStage,
        filteredEventsForCurrentStage: filteredEventsForCurrentStage,
        currentEventIdx: currentEventIdx,
        currentEvent: currentEvent,
        currentStage: currentStage
      };
    }

    var currentEventId = state.getIn(['stages', 'ui', feisId, 'currentEvent']);

    var currentEvent = currentEventId && eventsForCurrentStage.find(function (e) {
      return e.get('id') === currentEventId;
    }) || (0, _immutable.Map)();

    var currentEventIdx = currentEventId && filteredEventsForCurrentStage.findIndex(function (e) {
      return e.get('id') === currentEventId;
    }) || 0;

    return {
      loadingStagesDialog: false,
      stages: stages,
      currentStewardingDay: currentStewardingDay,
      allStagesForCurrentDay: allStagesForCurrentDay,
      eventsForCurrentStage: eventsForCurrentStage,
      filteredEventsForCurrentStage: filteredEventsForCurrentStage,
      currentEventIdx: currentEventIdx,
      currentEvent: currentEvent,
      currentStage: currentStage
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/stages/mapStateToDialogController.js
// module id = 573
// module chunks = 0